module.exports = __webpack_public_path__ + "img/mp4.e7c815a8.png";